import React from "react";
import LegalLayout from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated="April 26, 2026">
      <p>
        We want you to love every jingle you create. Here's our simple, fair refund policy.
      </p>

      <h2>1. Failed generations</h2>
      <p>
        If a jingle generation fails due to our system error, credits are <strong>automatically refunded</strong> within 60 seconds. You do not need to contact us.
      </p>

      <h2>2. Pay-per-use (₹799)</h2>
      <ul>
        <li><strong>Within 7 days and 0 credits used:</strong> Full refund on request.</li>
        <li><strong>Within 7 days and some credits used:</strong> Prorated refund — you pay only for credits consumed at the top-up rate (₹20 per credit).</li>
        <li><strong>After 7 days:</strong> No refund (credits never expire, so they remain usable).</li>
      </ul>

      <h2>3. Pro subscription (₹7,999/mo)</h2>
      <ul>
        <li>Cancel anytime from your dashboard or by emailing us — you will not be charged again.</li>
        <li>Remaining credits in the current billing cycle remain usable until consumed or the account is closed.</li>
        <li>Pro payments are <strong>non-refundable</strong> once the billing cycle has started, except in cases of (a) unauthorised charge, (b) clear service failure on our end, or (c) first-time subscription within 3 days of payment where no credits were consumed.</li>
      </ul>

      <h2>4. Top-ups (min ₹300)</h2>
      <ul>
        <li>Top-ups are refundable within 48 hours of payment if zero credits have been consumed.</li>
        <li>After any credit is used, top-ups become non-refundable (credits never expire).</li>
      </ul>

      <h2>5. How to request a refund</h2>
      <p>Email <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a> with:</p>
      <ul>
        <li>The email address on your account</li>
        <li>Payment transaction ID (from Razorpay receipt)</li>
        <li>Reason for the refund</li>
      </ul>
      <p>
        We respond within <strong>24 hours</strong> and process approved refunds to the original payment method within <strong>5-7 business days</strong>.
      </p>

      <h2>6. Chargebacks</h2>
      <p>
        Before initiating a chargeback with your bank, please contact us — we are much faster, and chargebacks may result in account suspension pending dispute resolution.
      </p>

      <h2>7. Contact</h2>
      <p>
        <strong>Email:</strong> <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a><br />
        <strong>Response time:</strong> Within 24 hours, business days
      </p>
    </LegalLayout>
  );
}
